import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidationUtilityService } from '../../shared/utils/validation.util/validation-utility.service';
import { METHOD_TYPE } from '../../../constants/service.constants';
import { Config } from '../../../config/config';
import { ServiceRouter } from '../../../services/core/http-service-router.service';
import { Environment } from '../../../config/environment';
import { VerificationBean } from '../../../beans/account/account-module.bean';
import { AppUtil } from '../../../utils/app.util';
import { JwtHelper } from '../../../services/core/jwt-helper.service';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';
import { Subscription } from 'rxjs';

@Component({
	selector: `app-ehe-code-verification-modal`,
	templateUrl: './code-verification-modal.component.html',
	styleUrls: ['./code-verification-modal.component.scss'],
})
export class CodeVerificationModalComponent implements OnInit, OnDestroy {
	form: FormGroup;
	code = '';
	codeInvalid: boolean = false;
	codeResent: boolean = false;
	subscriptions: Subscription[] = [];
	constructor(
		public fb: FormBuilder,
		private config: Config,
		private environment: Environment,
		private serviceRouter: ServiceRouter,
		private jwtService: JwtHelper,
		private spinner: SpinnerComponent,
		public dialogRef: MatDialogRef<CodeVerificationModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data
	) {}

	ngOnInit() {
		this.initializeCodeVerificationForm();
	}

	initializeCodeVerificationForm() {
		this.form = this.fb.group({
			code: [this.code, Validators.compose([Validators.required, ValidationUtilityService.verificationCodeValidator])],
		});
		this.subscriptions.push(
			this.form.get('code').valueChanges.subscribe(value => {
				this.codeInvalid = false;
			})
		);
	}

	save() {
		this.spinner.startLoader();
		this.codeInvalid = false;
		const epmsPID = this.jwtService.getEpmsId();
		const request = new VerificationBean();
		// Send code from result to services
		request.verificationCode = this.form.getRawValue().code;
		request.emailAddress = AppUtil.getFormattedEmail(this.data.email);
		request.uuid = this.data.uuid;
		request.emailType = this.data.emailType;
		const url = this.config.url.profileEmailsApi.baseUrl + `/${epmsPID}/emails/verification`;
		this.subscriptions.push(
			this.serviceRouter
				.makeRequest(this.environment.getEnvironment().EPMS_PROXY_BASE_URL, url, METHOD_TYPE.SECURED_POST, request)
				.subscribe(
					response => {
						this.spinner.stopLoader();
						this.dialogRef.close(true);
					},
					error => {
						this.spinner.stopLoader();
						this.form.controls.code.setErrors({ invalid: true });
						this.codeInvalid = true;
						this.codeResent = false;
					}
				)
		);
	}

	resendVerificationCode() {
		this.spinner.startLoader();
		this.codeResent = true;
		this.codeInvalid = false;
		const epmsPID = this.jwtService.getEpmsId();
		const request = {};
		request['emailAddress'] = this.data.email;
		request['uuid'] = this.data.uuid;
		request['emailType'] = this.data.emailType;
		const url = this.config.url.profileEmailsApi.baseUrl + `/${epmsPID}/emails/verification/resend`;
		this.subscriptions.push(
			this.serviceRouter
				.makeRequest(this.environment.getEnvironment().EPMS_PROXY_BASE_URL, url, METHOD_TYPE.SECURED_POST, request)
				.subscribe(
					response => {
						this.spinner.stopLoader();
						this.initializeCodeVerificationForm();
					},
					error => {
						this.spinner.stopLoader();
					}
				)
		);
	}

	close() {
		this.dialogRef.close();
	}

	actionFunction(e) {
		if (e.value === 'submit') {
			if (this.form.valid) {
				this.save();
			}
		} else {
			this.close();
		}
	}

	ngOnDestroy() {
		// prevent memory leak when component destroyed
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
		this.subscriptions = [];
	}
}
